import { createReducer } from 'utils/helpers';
import { MovementEnquiryActionTypes, IActions } from './MovementEnquiry.actions';
import { IPriceOverrideAuthorityDialogProperties } from 'components/common/PriceOverrideAuthorityDialog/PriceOverrideAuthorityDialog.properties';

export type IPriceOverrideDialogState<IApiType = any> = Omit<IPriceOverrideAuthorityDialogProperties<IApiType>, 'values' | 'resetForm' | 'onOk' | 'onCancel'>;
export interface IState {
    MovementEnquiry?: string;
    LineNumber?: number;
    SummaryPanelData?: any;
    ProcessMovementEnquiryDetails?: any;
    ReloadMovementEnquiry: boolean;
    IsChangeStatusDisabled: boolean;
    PreventChangeStatus: boolean;
}

export const initialState: IState = {
    MovementEnquiry: '',
    LineNumber: 0,
    SummaryPanelData: undefined,
    ProcessMovementEnquiryDetails: undefined,
    ReloadMovementEnquiry: false,
    IsChangeStatusDisabled: false,
    PreventChangeStatus: false
};

type IAction = (state: IState, payload: any) => IState;

type IActionMap = Record<MovementEnquiryActionTypes, IAction>;

const actionMap: IActionMap = {
    [MovementEnquiryActionTypes.setMovementEnquiry]: (state: IState, payload: IState['MovementEnquiry']): IState => ({ ...state, MovementEnquiry: payload }),
    [MovementEnquiryActionTypes.setLineNumber]: (state: IState, payload: IState['LineNumber']): IState => ({ ...state, LineNumber: payload }),
    [MovementEnquiryActionTypes.setSummaryPanelData]: (state: IState, payload: IState['SummaryPanelData']): IState => ({ ...state, SummaryPanelData: payload }),
    [MovementEnquiryActionTypes.setProcessMovementEnquiryDetails]: (state: IState, payload: IState['ProcessMovementEnquiryDetails']): IState => ({ ...state, ProcessMovementEnquiryDetails: payload }),
    [MovementEnquiryActionTypes.setReloadMovementEnquiry]: (state: IState, payload: IState['ReloadMovementEnquiry']): IState => ({ ...state, ReloadMovementEnquiry: payload }),
    [MovementEnquiryActionTypes.setIsChangeStatusDisabled]: (state: IState, payload: IState['IsChangeStatusDisabled']): IState => ({ ...state, IsChangeStatusDisabled: payload }),
    [MovementEnquiryActionTypes.setPreventChangeStatus]: (state: IState, payload: IState['PreventChangeStatus']): IState => ({ ...state, PreventChangeStatus: payload }),
};

export default createReducer<IActionMap, IState, IActions>(actionMap);
